export const CURRENT_USER = "CURRENT_USER";
export const LOG_OUT = "LOG_OUT";
export const SET_USER_FCM_TOKEN_SUCCESS = "SET_USER_FCM_TOKEN_SUCCESS";
